import userJobDetail from './userJobDetail';
import mystudents from './mystudents';
import detail from './detail';
import getSoftSkills from './getSoftSkills';
import updateStudentSoftskills from './updateStudentSoftskills';

export default {
  userJobDetail,
  mystudents,
  detail,
  getSoftSkills,
  updateStudentSoftskills,
};
